import React from "react";
import { useNavigate } from "react-router-dom";
import "./Catalog.css";

import bonnetImg from "../assets/Bonnet.jpg";
import FadeImg from "../components/FadeImg";
import { useNavDirection } from "../NavDirectionContext";

// Liste des produits du drop.
// Pour un nouveau produit cliquable : ajouter une entrée ici + sa route dans App.js.
//
// ⚠️ Le slug reste "bonnet" alors que le nom affiché est "imani" : c'est lui qui
// fait l'URL /shop/bonnet, présente dans public/sitemap.xml et déjà connue des
// moteurs. Le renommer casserait le lien sans rien apporter au visiteur.
//
// Le polo et le tee-shirt ont été retirés le 20/09/2026 : seul le bonnet est
// vendu sur ce drop. Leurs routes restent déclarées dans App.js — les supprimer
// ferait de /shop/polo une page blanche, faute de page 404.
const PRODUCTS = [
  { slug: "bonnet", name: "imani", price: "39,99€", img: bonnetImg, soon: false },
];

export default function Catalog() {
  const navigate = useNavigate();
  const { setDir } = useNavDirection();

  const goBack = () => {
    setDir("down");
    navigate("/");
  };

  const openProduct = (slug) => {
    setDir("up");
    navigate(`/shop/${slug}`);
  };

  return (
    <div className="catalog">
      <button className="catalog__back" onClick={goBack}>
        back
      </button>

      <div className="catalog__scroll">
        <main className="catalog__grid">
          {PRODUCTS.map((p) => (
            <button
              key={p.slug}
              className="catalog__card"
              onClick={() => openProduct(p.slug)}
              type="button"
            >
              <div className="catalog__imgWrap">
                {p.img ? (
                  <FadeImg
                    className="catalog__img"
                    src={p.img}
                    alt={p.name}
                    draggable="false"
                  />
                ) : (
                  <div className="catalog__placeholder" aria-hidden="true" />
                )}
              </div>

              <div className="catalog__name">{p.name}</div>
              <div className="catalog__price">{p.price}</div>
              {p.soon && <div className="catalog__soonLabel">(coming soon)</div>}
            </button>
          ))}
        </main>
      </div>
    </div>
  );
}
